export default "__VITE_ASSET__C7KQhdHL__"